import { useEffect } from "react";
import { drawCanvas } from "../utils/drawCanvas";

export function useDrawCanvas({
  canvasRef,
  img,
  scale,
  offset,
  grid,
}) {
  useEffect(() => {
    if (!img) return;

    drawCanvas({
      canvas: canvasRef.current,
      image: img,
      scale,
      offset,
      grid,
    });
  }, [canvasRef, img, scale, offset, grid]);
}